import { c as _c } from "react/compiler-runtime";
import type { HighlighterCore } from 'shiki';
import { atom, useAtom } from 'jotai';
const instanceAtom = atom<HighlighterCore | null>(null);
let initPromise: Promise<void> | null = null;
const highlighterAtom = atom(get => get(instanceAtom), async (get, set) => {
  if (get(instanceAtom)) return;
  if (initPromise) {
    await initPromise;
    return;
  }
  initPromise = (async () => {
    const {
      createHighlighter
    } = await import('shiki');
    const {
      createJavaScriptRegexEngine
    } = await import('shiki/engine/javascript');
    const instance = await createHighlighter({
      langs: [],
      themes: ['github-light-default', 'github-dark-default'],
      engine: createJavaScriptRegexEngine()
    });
    set(instanceAtom, instance);
  })();
  try {
    await initPromise;
  } finally {
    initPromise = null;
  }
});
export function useHighlighter() {
  const $ = _c(3);
  const [highlighter, initHighlighter] = useAtom(highlighterAtom);
  let t0;
  if ($[0] !== highlighter || $[1] !== initHighlighter) {
    t0 = {
      highlighter,
      initHighlighter
    };
    $[0] = highlighter;
    $[1] = initHighlighter;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}